// extracted by mini-css-extract-plugin
module.exports = {"text":"CategoryIntro-module--text--hLN4i","isGrey":"CategoryIntro-module--isGrey--326hf"};